// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Z9jIRPyJd8VrRx5C7SuA label {
    font-weight: normal;
    margin-bottom: 0;
}

.CBgkq1_YmPYHyae8ahsr > .form-group > label.control-label {
    margin-bottom: 4px;
    font-weight: 600;
}

.CBgkq1_YmPYHyae8ahsr + .CBgkq1_YmPYHyae8ahsr {
    margin-top: 18px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/eligibility/components/form.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".form label {\n    font-weight: normal;\n    margin-bottom: 0;\n}\n\n.question > :global(.form-group > label.control-label) {\n    margin-bottom: 4px;\n    font-weight: 600;\n}\n\n.question + .question {\n    margin-top: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `Z9jIRPyJd8VrRx5C7SuA`,
	"question": `CBgkq1_YmPYHyae8ahsr`
};
export default ___CSS_LOADER_EXPORT___;
